export const PARCEL_JOURNEY_TYPE_FORWARD = 'FORWARD'

export const TRACK_PARCEL_CTA_TRACK_CLICK_NAME = 'Track shipment CTA'
export const TRACK_PARCEL_CTA_TRACK_CLICK_ZONE = 'my_orders'

export const CARRIER_TRACKING_URL_TRACK_CLICK_NAME = 'Carrier tracking'
export const CARRIER_TRACKING_URL_TRACK_CLICK_ZONE = 'track_parcel'

export const TRACK_PARCEL_TRACK_CLICK_TARGET_CARRIER = 'CARRIER'
export const TRACK_PARCEL_TRACK_CLICK_TARGET_INTERNAL = 'INTERNAL'
